// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VxTG","title":"styles_title__3BFV7"};